import React from "react";
import { useSelector } from "react-redux";
import { Divider } from "@material-ui/core";
import LocalNavMenu from "../LocalNavMenu";
import LocalNavSoftLink from "../LocalNavSoftLink";
import LocalNavHardLink from "../LocalNavHardLink";

export default function ClientAdminMenu() {
    const pathname = useSelector(state => state.router.location.pathname);
    const roles = useSelector(state => state.session.roles);
    const companyId = useSelector(state => state.session.companyId);

    const hasClientAdmin = roles.includes("Client Admin");
    const hasSuperAdmin = roles.includes("Super Admin");
    const hasExperianAdmin = roles.includes("Experian Admin");
    const showClientAdminOnly = hasClientAdmin && !hasSuperAdmin && !hasExperianAdmin;
    if (!showClientAdminOnly) return null;

    const hasCompanySelected = companyId != null && companyId > 0;
    const isActive = pathname.includes("/admin/");

    return (
        <li id="client-admin" className={`menu-li ${isActive ? "active" : ""}`}>
            <LocalNavMenu
                id="client-admin-menu"
                key="clientAdmin"
                text="Admin"
                isCollapsed
                collapsedIcon="/Images/Icons/certified.png"
            >
                <div className="nav-description" name="description">
                    <strong>Client Admin</strong>
                </div>
                <Divider name="divider" />
                <LocalNavSoftLink id="user-admin" destination="/admin/users" text="Users" removeLi />
                {hasCompanySelected && <Divider name="divider" />}
                {hasCompanySelected && (
                    <LocalNavSoftLink
                        id="image-control"
                        destination="/admin/image-control"
                        text="Image Control"
                        removeLi
                    />
                )}
                {hasCompanySelected && (hasSuperAdmin || hasExperianAdmin) && (
                    <LocalNavHardLink
                        id="distribution-list"
                        destination="/admin/distribution-list"
                        text="Distribution List"
                        removeLi
                    />
                )}
            </LocalNavMenu>
        </li>
    );
}
